import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'

import { Form, Input, Button } from './../../components/Form'
import { useLayout } from './../../context/Layout'
import { useTheme } from './../../context/Theme'
import api from './../../api'
import './style.scss'

function EsqueciSenha() {

    const [load, setLoad] = useState(false)
    const [showCodigo, setShowCodigo] = useState(false)
    const [email, setEmail] = useState('')
    const [finish, setFinish] = useState(false)
    const [validacao, setValidacao] = useState('')

    const { isScreenLogin } = useLayout()
    const { theme } = useTheme()

    useEffect(() => {
        isScreenLogin(true)
        return () => isScreenLogin(false)
    }, [isScreenLogin])

    async function onReset(data) {

        setLoad(true)
        setEmail(data.email)

        try {
            const resp = await api.post('login/esqueciSenha', { email: data.email })

            setFinish(false)
            setLoad(false)

            if (resp.data.type === 1) {
                setValidacao(resp.data.mensagem)
                return
            }

            document.querySelector('input').value = ''
            setShowCodigo(true)
        } catch (error) {
            setLoad(false)
        }
    }

    async function onValidCodigo(data) {

        setFinish(false)
        setLoad(true)

        try {
            const resp = await api.post('login/validaCodigoRecuperacao', {
                codigo: data.codigo,
                email,
            })

            if (resp.data === 1)
                setFinish(true)
            else
                setShowCodigo(false)
        } catch (error) {
            setLoad(false)
        }
        setLoad(false)
    }

    const renderHeader = (title, subtitle) => (
        <div className='cadastro--header'>
            <h1 className="cadastro-title">{title}</h1>
            <p className="cadastro-subtitle">{subtitle}</p>
        </div>
    )

    const content = () => {
        if (finish) {
            return (
                <div className="finish-message">
                    {renderHeader('Nova Senha', 'Enviamos sua nova senha para seu e-mail. Por favor, verifique sua caixa de entrada.')}
                    <div className="submit-container">
                        <Link to='/' className="btn-primary-link">Voltar para o Login</Link>
                    </div>
                </div>
            )
        }

        if (showCodigo) {
            return (
                <Form onSubmit={onValidCodigo} className='auth-form'>
                    {renderHeader('Código de Recuperação', `Enviamos um código para ${email}. Digite-o abaixo para validar.`)}

                    <Input name='codigo' titulo='Código' placeholder='Digite o Código' />

                    <div className="submit-container">
                        <Button load={load} name='Validar Código' icon={<i className="fas fa-check-circle"></i>} />
                    </div>
                </Form>
            )
        }

        return (
            <Form onSubmit={onReset} className='auth-form'>
                {renderHeader('Esqueci minha senha', 'Digite seu e-mail abaixo e enviaremos as instruções para recuperar sua conta.')}

                <Input name='email' titulo='E-mail' placeholder='Digite seu e-mail' />

                <div className="submit-container">
                    <Button load={load} name='Recuperar Senha' icon={<i className="fas fa-paper-plane"></i>} />
                    {validacao && <div className="validaRetorno">{validacao}</div>}
                </div>
            </Form>
        )
    }

    return (
        <div className="login-page">
            <div className="login-container">
                <div className="login-header">
                    <img src={theme === 'dark' ? "/assets/images/logo/logobranca.svg" : "/assets/images/logo/logo.svg"} alt="Ambientar Logo" className="login-logo" />
                    <p className='subtit'>GERENCIADOR DE LICENÇAS E CONDICIONANTES</p>
                </div>

                <div className="login-card">
                    <div className="login-form-wrapper">
                        {content()}
                    </div>
                </div>

                {!finish && (
                    <div className="login-footer">
                        <p><Link to='/'>Voltar para o Login</Link></p>
                    </div>
                )}
            </div>
        </div>
    )
}

export default EsqueciSenha